import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ColorModeProvider } from './hooks/useColorMode';
import './i18n/i18n';

// Pages
import HomePage from './pages/HomePage';
import QueGanasPage from './pages/QueGanasPage';
import ComoFuncionaPage from './pages/ComoFuncionaPage';
import PlanesPage from './pages/PlanesPage';
import MisionVisionPage from './pages/MisionVisionPage';
import ContactoPage from './pages/ContactoPage';

export default function App(): JSX.Element {
  return (
    <ColorModeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/que-ganas" element={<QueGanasPage />} />
          <Route path="/como-funciona" element={<ComoFuncionaPage />} />
          <Route path="/planes" element={<PlanesPage />} />
          <Route path="/mision-vision" element={<MisionVisionPage />} />
          <Route path="/contacto" element={<ContactoPage />} />
        </Routes>
      </BrowserRouter>
    </ColorModeProvider>
  );
}
